import { apiClient } from '@shared/utils/api-client';

export interface MySellerSales {
    sellerId: number;
    shopName: string;
    slug: string;
    ordersCount: number;
    itemsSold: number;
    grossRevenue: number;
    commissionPercent: number;
    commissionAmount: number;
    netToSeller: number;
}

export interface SellerDashboardDay {
    date: string;
    revenue: number;
    ordersCount: number;
}

export interface SellerDashboardTopProduct {
    productId: number;
    name: string;
    quantitySold: number;
    revenue: number;
}

export interface SellerDashboardResponse {
    sellerId: number;
    shopName: string;
    slug: string;
    ordersCount: number;
    itemsSold: number;
    grossRevenue: number;
    averageOrderValue: number;
    commissionPercent: number;
    commissionAmount: number;
    promotionDeduction: number;
    netToSeller: number;
    daily: SellerDashboardDay[];
    topProducts: SellerDashboardTopProduct[];
}

export const sellerSalesApi = {
    getMe: (params?: { dateFrom?: string; dateTo?: string }) => {
        const search = new URLSearchParams();
        if (params?.dateFrom) search.set('dateFrom', params.dateFrom);
        if (params?.dateTo) search.set('dateTo', params.dateTo);
        const q = search.toString();
        return apiClient.get<MySellerSales>(`/seller-sales/me${q ? `?${q}` : ''}`);
    },

    getMeDashboard: (params?: { dateFrom?: string; dateTo?: string }) => {
        const search = new URLSearchParams();
        if (params?.dateFrom) search.set('dateFrom', params.dateFrom);
        if (params?.dateTo) search.set('dateTo', params.dateTo);
        const q = search.toString();
        return apiClient.get<SellerDashboardResponse>(`/seller-sales/me/dashboard${q ? `?${q}` : ''}`);
    },
};
